import React from 'react';

import StringInput from 'components/PortalFormFields/InputFields/StringInput';
import { FieldTypeComponentProps } from 'modules/FormGenerator/propTypes';

const StringTypeField = ({ field: { name, value, placeholder, hasError }, onChange }) => (
  <StringInput
    name={name}
    value={value}
    placeholder={placeholder}
    onChange={onChange}
    hasError={hasError}
  />
);

StringTypeField.propTypes = FieldTypeComponentProps;

export default StringTypeField;
